import { render, staticRenderFns } from "./ExpeditiiDocument.vue?vue&type=template&id=6fb9b63c&scoped=true&"
import script from "./ExpeditiiDocument.ts?vue&type=script&lang=ts&"
export * from "./ExpeditiiDocument.ts?vue&type=script&lang=ts&"
import style0 from "./ExpeditiiDocument.vue?vue&type=style&index=0&id=6fb9b63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb9b63c",
  null
  
)

export default component.exports
import {QSpinnerGears,QCardSection,QTooltip,QPopupProxy,QCard,QItem,QItemSection,QItemLabel,QSeparator,QInput,QDate,QIcon,QBtn,QField,QMenu,ClosePopup} from 'quasar'
component.options.components = Object.assign({QSpinnerGears,QCardSection,QTooltip,QPopupProxy,QCard,QItem,QItemSection,QItemLabel,QSeparator,QInput,QDate,QIcon,QBtn,QField,QMenu}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
